import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { rgba } from 'polished';

import Colours from '../definitions/Colours';
import Sizes from '../definitions/Sizes';
import MessagePropType from '../definitions/MessagePropType';
import Paragraph from './Paragraph';
import RejectButton from './RejectButton';
import AlternateButton from './AlternateButton';


const SIZE = {
    NORMAL: 'normal',
    SMALL: 'small',
};

function DeleteConfirmationBlock({
    titleMessage,
    descriptionMessage,
    confirmMessage,
    rejectMessage,
    onConfirmClick,
    onRejectClick,
    name,
    size,
    ...otherProps
}) {

    return (
        <div {...otherProps}>
            <div className="content-container">
                <Paragraph
                    className="title"
                    message={titleMessage}
                    size={size === SIZE.NORMAL
                        ? 'large'
                        : 'normal'}
                />

                <If condition={descriptionMessage}>
                    <Paragraph
                        className="description"
                        size="small"
                        message={descriptionMessage}
                    />
                </If>

                <div className="button-container">
                    <RejectButton
                        className="modal-button"
                        variant="primary"
                        size={size === SIZE.NORMAL
                            ? 'large'
                            : 'medium'}
                        onClick={onConfirmClick}
                        message={confirmMessage}
                        data-name={`${name}-accept`}
                        type="button"
                    />

                    <AlternateButton
                        className="modal-button"
                        size={size === SIZE.NORMAL
                            ? 'large'
                            : 'medium'}
                        onClick={onRejectClick}
                        message={rejectMessage}
                        data-name={`${name}-reject`}
                        type="button"
                    />
                </div>
            </div>
        </div>
    );
}

DeleteConfirmationBlock.propTypes = {
    titleMessage: MessagePropType.isRequired,
    descriptionMessage: MessagePropType,
    confirmMessage: MessagePropType.isRequired,
    rejectMessage: MessagePropType.isRequired,
    onConfirmClick: PropTypes.func.isRequired,
    onRejectClick: PropTypes.func.isRequired,
    name: PropTypes.string,
    size: PropTypes.oneOf(Object.values(SIZE)),
};

DeleteConfirmationBlock.defaultProps = {
    descriptionMessage: undefined,
    name: 'DeleteConfirmationBlock',
    size: SIZE.NORMAL,
};


const StyledDeleteConfirmationBlock = styled(DeleteConfirmationBlock)`
    display: flex;
    align-items: center;
    justify-content: center;

    padding: ${Sizes.SPACING.FOUR} 0;
    background-color: ${rgba(Colours.COCONUT, 0.97)};

    >.content-container {
        max-width: 800px;
        flex: 100% 1 0;

        width: 100%;

        box-sizing: border-box;

        ${props => props.size === SIZE.NORMAL && `
            padding: ${Sizes.SPACING.FOUR} ${Sizes.SPACING.TWO};
        `}
        

        >.title {
            margin: 0;
            padding: 0 ${Sizes.SPACING.TWO};
            text-align: center;
        }

        >.description {
            margin-top: ${Sizes.SPACING.HALF};
            text-align: center;
        }


        >.button-container {
            display: flex;
            flex-wrap: wrap;
            align-items: center;
            justify-content: space-around;

            max-width: 600px;
            margin: ${Sizes.SPACING.ONE_AND_A_HALF} auto 0;

            ${props => props.size === SIZE.NORMAL && `
                margin-top: ${Sizes.SPACING.THREE};
            `}

            >.modal-button {
                flex: 200px 1 0;
                margin: ${Sizes.SPACING.QUARTER} ${Sizes.SPACING.HALF};
            }
        }
    }
`;


export default StyledDeleteConfirmationBlock;